import React, { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@mui/material';
import { FormBuilder } from './FormBuilder';
import { SimpleFormSection } from '../../components/Sections';
import { FormField } from '../../interfaces/User.interface';
import { generateValidationSchema } from './Validators';

interface DynamicFormProps {
    formFields: FormField[];
    prefilled?: Record<string, any>;
    onSubmit: (data: any) => void;
    onFieldChange?: (fieldName: string, value: any) => void;
}

const FDynamicForm: React.FC<DynamicFormProps> = ({ formFields, prefilled, onSubmit, onFieldChange}) => {
    const validationSchema = useMemo(() => generateValidationSchema(formFields), [formFields]);

    const { handleSubmit, control, formState: { errors }, reset } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onTouched',
        defaultValues: prefilled,
    });
    useEffect(() => {
        reset(prefilled);
    }, [prefilled, reset])
    const formContent = FormBuilder(formFields, control, errors, onFieldChange); // Change this to useMemo will disable onTouched mode
    // const formContent = useMemo(() => FormBuilder(formFields, control, errors), [formFields, control, errors]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <SimpleFormSection title="">
                {formContent}
            </SimpleFormSection>
            <Button onClick={handleSubmit(onSubmit)} variant="contained" color="primary" className="w-full" style={{ fontSize: '1.25rem' }}>
                Save
            </Button>
        </form>
    );
};

export default FDynamicForm;
